export const LOGIN_CHECK = 'LOGIN_CHECK';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
